/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Table_TitleInputs */

const en_pol_table_title = /** @type {(inputs: Pol_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider × way of use`)
};

const id_pol_table_title = /** @type {(inputs: Pol_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyedia × cara pakai`)
};

/**
* | output |
* | --- |
* | "Provider × way of use" |
*
* @param {Pol_Table_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_table_title = /** @type {((inputs?: Pol_Table_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Table_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_table_title(inputs)
	return en_pol_table_title(inputs)
});